import React from 'react';
import PropTypes from 'prop-types';
import { StarPicker } from 'react-star-picker';
import { Link } from 'gatsby';
import isNil from 'utils/isNil';
import colorTypeHelper from 'utils/colorTypeHelper';
import { WebsiteImage } from 'components/TitleDescription';
import MarketoForm from 'components/Form/MarketoForm';
import { STLogo } from 'components/Brand/Logos/STLogo';
import useAnimatedTrustbar from 'hooks/useAnimatedTrustbar';
import { SectionDemoHero1 } from './styles';

const DemoHeroSection1 = ({
  backgroundColor,
  title,
  description,
  leftSide,
  reviews,
  trustedSection,
  demoForm,
  initEmailValue,
}) => {
  const animatedTrustbar = useAnimatedTrustbar();
  const bgColor = colorTypeHelper[backgroundColor];
  const formFooterLink =
    '//assets.ctfassets.net/3q1a0w8cwuwf/6IVnzKrfiNO3x5gtU3GHIo/bdc4799a24d55880eead88cd76015a11/ServiceTitan_-_Privacy_Policy_2020_Final_1.1.20.pdf';
  return (
    <SectionDemoHero1 backgroundColor={bgColor} leftSide={leftSide}>
      <div className="section-demo-hero--wrapper">
        <div className="section-demo-hero--container">
          <div className="section-demo-hero--top-side">
            <div className="section-demo-hero--logo-wrapper">
              <Link to="/">
                <STLogo />
              </Link>
            </div>
            <div className="section-demo-hero--text-content">
              <h2 className="section-demo-hero--title">{title}</h2>
              <p className="section-demo-hero--description">{description}</p>
            </div>
            <div className="section-demo-hero--form-section">
              <div className="section-demo-hero--form-left-side">
                <h2 className="section-demo-hero--left-title">{leftSide.title}</h2>
                {leftSide.reviews && !isNil(leftSide.reviews[0]) && (
                  <div className="section-demo-hero--form-left-bottom">
                    <div className="section-demo-hero--rate-content">
                      <StarPicker
                        name="rating1"
                        className="section-demo-hero--rate-star"
                        value={leftSide.reviews[0].stars}
                        halfStars
                        disabled
                        size={40}
                        starRendererProps={{
                          colorActive: leftSide.reviews[0].starColor,
                          colorInactive: leftSide.reviews[0].starOffColor,
                        }}
                      />
                      <p className="section-demo-hero--rate-description">
                        {leftSide.reviews[0].title}
                      </p>
                    </div>

                    <div className="section-demo-hero--rate-logo-content">
                      {!isNil(leftSide.reviews[0].companyLogos) &&
                        leftSide.reviews[0].companyLogos.map((item, index) => {
                          return (
                            <div className="section-demo-hero--rate-logo-item" key={index}>
                              <WebsiteImage src={item} />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>

              <div className="section-demo-hero--form-right-side">
                <MarketoForm
                  dataPosition="Hero"
                  backgroundColor={demoForm.formBackgroundColor}
                  titleColor={demoForm.formTitleColor}
                  title={demoForm.formTitle}
                  termsText={demoForm.termsText}
                  redirectUrl={demoForm?.redirectUrl}
                  initEmailValue={initEmailValue}
                  buttonLabel={demoForm.formButtonTitle}
                  marketoForm={demoForm?.marketoForm}
                  className="section-demo-hero--signup-form"
                  shadow={false}
                />
              </div>
            </div>

            <p className="section-demo-hero--form-section-footer">
              By submitting this form, I confirm that I have read and agree to the{' '}
              <a href={formFooterLink}>Privacy Statement.</a>
            </p>
          </div>
          <div className="section-demo-hero--bottom-side">
            {reviews && !isNil(reviews[1]) && (
              <div className="section-demo-hero--rate-content">
                <StarPicker
                  name="rating1"
                  className="section-demo-hero--rate-star"
                  value={reviews[1].stars}
                  halfStars
                  disabled
                  size={40}
                  starRendererProps={{
                    colorActive: reviews[1].starColor,
                    colorInactive: reviews[1].starOffColor,
                  }}
                />
                <p className="section-demo-hero--rate-description">{reviews[1].title}</p>
              </div>
            )}
            {reviews && !isNil(reviews[1]) && (
              <div className="section-demo-hero--rate-logo-content">
                {reviews[1].companyLogos.map((item, index) => {
                  return (
                    <div className="section-demo-hero--rate-logo-item" key={index}>
                      <WebsiteImage src={item} />
                    </div>
                  );
                })}
              </div>
            )}
            {trustedSection && (
              <div className="section-demo-hero--trusted-content">
                <h2 className="section-demo-hero--trusted-title">{trustedSection.title}</h2>
              </div>
            )}
            {animatedTrustbar ? (
              <div className="section-demo-hero--animated-trustbar-container">
                <div
                  style={{
                    background: `url(${animatedTrustbar.image.file.url}) left center/auto 70px repeat-x`,
                  }}
                  className="section-demo-hero--animated-trustbar"
                ></div>
              </div>
            ) : trustedSection ? (
              <div className="section-demo-hero--trusted-logo-content">
                {!isNil(trustedSection.imgs) &&
                  trustedSection.imgs.map((item, index) => {
                    return (
                      <div className="section-demo-hero--trusted-logo-item" key={index}>
                        <WebsiteImage src={item} />
                      </div>
                    );
                  })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </SectionDemoHero1>
  );
};

DemoHeroSection1.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  backgroundColor: PropTypes.string,
  formTitle: PropTypes.string,
  initEmailValue: PropTypes.string,
};

export default DemoHeroSection1;
